import { render, staticRenderFns } from "./ConversationSelectableMessage.vue?vue&type=template&id=4460c566&"
import script from "./ConversationSelectableMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationSelectableMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports